import MuiPaper, { PaperProps as MuiPaperProps } from '@mui/material/Paper';
import clsx from 'clsx';
import classes from './Paper.module.scss';

export default function Paper({ children, className, ...rest }: PaperProps) {
  return (
    <MuiPaper className={clsx(classes.root, className)} {...rest}>
      {children}
    </MuiPaper>
  );
}

export type PaperProps = MuiPaperProps;
